const initialState = {
    stack: [],
    status: true,
};

// Fire-and-forget API calls that shouldn't block the UI with the global
// preloader — UX is already settled before the round-trip completes
// (e.g. night mode toggles theme instantly via cookie + body class).
const BACKGROUND_ACTIONS = [
    'SWITCH_NIGHT_MODE',
];

export default function PreloaderReducer(state = initialState, action) {
    let parsedType = action.type.toString().match(/^(.+)_(INIT|SUCCESS|FAILURE)$/);

    if (parsedType && !BACKGROUND_ACTIONS.includes(parsedType[1])) {
        switch (parsedType[2]) {
            case "INIT":
                state = {
                    stack: state.stack.concat([parsedType[1]]),
                }
                break;

            case "SUCCESS":
            case "FAILURE":
                state = {
                    stack: state.stack.filter(item => item !== parsedType[1]),
                }
        }

        state.status = !!state.stack.length;
    }

    return state
}
